module.exports = __webpack_public_path__ + "img/C08TechIndrasProsperityRM_ua.aad44f71.webp";